import { Link } from "react-router-dom";
import { ArrowUp, Envelope, GeoAlt, GooglePlay, Telephone } from "react-bootstrap-icons";
import { getIcon } from "./icons";
import {
  ASSETS,
  CONTACT,
  FOOTER_BOTTOM_LINKS,
  FOOTER_COLUMNS,
  PLAY_STORE_URL,
  SOCIALS,
} from "./data/landingData";

/** One footer for every public page. */
const LandingFooter = () => (
  <footer className="lp-footer">
    <div className="container">
      <div className="row g-5">
        <div className="col-12 col-md-6 col-lg-3">
          <Link to="/" aria-label="All Home Desire home">
            <img src={ASSETS.logo} alt="All Home Desire" className="lp-footer__logo" height="38" loading="lazy" />
          </Link>
          <p className="lp-footer__text">
            India&apos;s modern real estate platform, making it transparent, verified and effortless to buy,
            sell and rent a home.
          </p>
          <div className="d-flex gap-2">
            {SOCIALS.map(({ name, icon, href }) => {
              const Icon = getIcon(icon);
              return (
                <a
                  key={name}
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="lp-footer__social"
                  aria-label={`${name} (opens in a new tab)`}
                >
                  <Icon aria-hidden="true" />
                </a>
              );
            })}
          </div>
        </div>

        {FOOTER_COLUMNS.map(({ title, links }) => (
          <nav key={title} className="col-6 col-md-3 col-lg-2" aria-label={title}>
            <h3 className="lp-footer__heading">{title}</h3>
            <ul className="list-unstyled mb-0">
              {links.map(({ to, label }) => (
                <li key={label}><Link to={to} className="lp-footer__link">{label}</Link></li>
              ))}
            </ul>
          </nav>
        ))}

        <div className="col-12 col-md-6 col-lg-3">
          <h3 className="lp-footer__heading">Get the App</h3>
          <a href={PLAY_STORE_URL} target="_blank" rel="noopener noreferrer" className="lp-store lp-store--sm" aria-label="Get it on Google Play (opens in a new tab)">
            <GooglePlay aria-hidden="true" />
            <span><small>Get it on</small>Google Play</span>
          </a>

          <h3 className="lp-footer__heading mt-4">Get In Touch</h3>
          <address className="lp-footer__contact">
            <p><GeoAlt aria-hidden="true" /> <span>{CONTACT.address}</span></p>
            <p><Telephone aria-hidden="true" /> <a href={CONTACT.phoneHref}>{CONTACT.phone}</a></p>
            <p><Envelope aria-hidden="true" /> <a href={`mailto:${CONTACT.email}`}>{CONTACT.email}</a></p>
          </address>
        </div>
      </div>

      <div className="lp-footer__bottom">
        <p className="mb-0">&copy; {new Date().getFullYear()} All Home Desire. All rights reserved.</p>
        <ul className="d-flex flex-wrap gap-4 list-unstyled mb-0">
          {FOOTER_BOTTOM_LINKS.map(({ to, label }) => (
            <li key={label}><Link to={to} className="lp-footer__link">{label}</Link></li>
          ))}
          <li>
            <button type="button" className="lp-footer__top" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}>
              <ArrowUp aria-hidden="true" /> Back to top
            </button>
          </li>
        </ul>
      </div>
    </div>
  </footer>
);

export default LandingFooter;
